import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type RouterService from '@ember/routing/router-service';
// This is for types. Anything we have custom may show an error.
import type { Store as StoreService } from '@warp-drive/core';
import type { ObservableDocumentExtension as ObservableDocumentModel } from 'tio-data/data/resources/observable-document.ext';

type RouteParams = {
  observable_document_id: string;
};

export default class AuthenticatedObservabilityDisputeRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;

  async model(params: RouteParams) {
    // fetch loan here for account information section
    // WarpDrive builder read (Phase 2.4) — replaces store.findRecord.
    const { content } = (await this.store.request(
      findRecord<ObservableDocumentModel>('observable-document', params['observable_document_id'], {
        include: 'observable-asset',
      })
    )) as { content: { data: ObservableDocumentModel } };

    return content.data;
  }

  async afterModel(observableDocument: ObservableDocumentModel) {
    const providerTypeDisputable = [
      'ObservableProvider.ACCOUNT_STATEMENT',
      'ObservableProvider.NSLDS',
    ].includes(observableDocument?.provider);

    const subsistenceStateDisputable =
      observableDocument.subsistenceState !== 'SubsistenceState.IMPLICIT';

    if (providerTypeDisputable && subsistenceStateDisputable) {
      this.router.transitionTo('authenticated.observability.documents.show', observableDocument);
    }
  }
}
